import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false,
    historyActions: new Map()
});
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'FHE__UPDATE_HOME_PRODUCTS':
            return core.setHomeProductsInitialized(state, action.homeId);
        case 'FHE__SET_HOMES':
            return core.setHomes(state, action.homes);
        case 'FHE__SET_HISTORY_ACTIONS':
            return core.setHistoryActions(state, action.historyActions);
        case 'FHE__UPDATE_HOMES':
            return core.updateHomes(state, action.homes);
        case `FHE__UPDATE_HOME`:
            return core.updateHome(state, action.homeId, action.homeDetails);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Homes/reducer.js